import {attributes, type} from '@type-r/models';

const OrgInfoModel = ({ optional } = { optional : false }) => {
  const RequiredString = optional ?
    type( String ) :
    type( String ).required;

  return attributes({
    address : {
      line_one: RequiredString,
      line_two: '',
      city: RequiredString,
      state_province: '',
      postal_code: RequiredString,
      country: RequiredString
    },

    contact : {
      name : RequiredString,
      phone : '',
      email : ''
    },
    name : RequiredString
  });
}

export type OrgInfo = InstanceType<typeof OrgInfo>
export const OrgInfo = OrgInfoModel();
export type OptionalOrgInfo = InstanceType<typeof OptionalOrgInfo>
export const OptionalOrgInfo = OrgInfoModel({ optional : true });
